import React from 'react';
import './Loader.scss';

const Loader = (props) => {
  return(
    <div className={"loader "+(props.isLoading ? "active" : "")}></div>
  )
}

export default Loader;